module.exports = __webpack_public_path__ + "media/images/détecteurs de fumée-a6c472fe4a8b3c2ffe9b0933bb056e54.svg";